import { Team__Potras } from "../teams/Potras";
import { Team__Cerveceras } from "../teams/Cerveceras";
import { Team__Abejas } from "../teams/Abejas";
import { Team__Omega } from "../teams/Omega";

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 29,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceras = {
  team: Team__Cerveceras,
  playingPlayers: [],

  goals: 40,
  penaltyGoals: 0,
  isWinner: false,
};

const Abejas = {
  team: Team__Abejas,
  playingPlayers: [],

  goals: 21,
  penaltyGoals: 0,
  isWinner: false,
};

const Omega = {
  team: Team__Omega,
  playingPlayers: [],

  goals: 24,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: Potras,
      team2: Cerveceras,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "09:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Abejas,
      team2: Omega,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "10:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
